<template>
    <!-- 服务部分 -->
    <section class="leafly-section bg-gray-50">
        <div class="container mx-auto px-4">
            <div class="flex flex-col md:flex-row justify-between items-start mb-8">
                <div>
                    <h2 class="leafly-section-title ">Services that meet your packaging needs</h2>
                    <p class="leafly-section-second-title">Never worry about going to multiple sources to get your dream packaging.</p>
                </div>
                <div class="hidden md:block mt-[-12px] md:mt-0">
                    <nuxt-link :to="'/custom-packaging'" class="flex items-center text-green-600 font-weight-600 hover:text-green-700 mt-4">
                        CUSTOM PACKAGING
                        <svg version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 200 200" style="enable-background: new 0 0 200 200; width: 24px; height: 24px" xml:space="preserve">
                            <path fill="currentColor" d="M151.6,51.7l0,98.1c0,0.9-0.7,1.6-1.6,1.6c-0.4,0-0.8-0.2-1.1-0.5L147,149c-0.6-0.6-0.9-1.4-0.9-2.2l0-86.8l-90.5,90.6c-0.6,0.6-1.6,0.6-2.2,0l-2.1-2.1c-0.6-0.6-0.6-1.6,0-2.2l90.6-90.6l-86.8,0c-0.8,0-1.6-0.3-2.2-0.9l-1.9-1.9c-0.6-0.6-0.6-1.6,0-2.2c0.3-0.3,0.7-0.5,1.1-0.5l98.1,0C150.9,50.2,151.6,50.9,151.6,51.7L151.6,51.7z" />
                        </svg>
                    </nuxt-link>
                </div>
            </div>

            <div class="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-6 gap-4 mb-8">
                <!-- 咨询服务 -->
                <div class="flex flex-col item" data-aos="fade-up" data-aos-delay="100">
                    <div class="card-header bg-[rgb(35,186,152)] text-white flex items-center justify-center text-center h-32 rounded-t-md">
                        <h3 class="text-xl font-weight-600 mb-0 text-center">Consultation</h3>
                    </div>
                    <div class="bg-[rgb(223,223,223)] p-4  rounded-b-md flex-grow">
                        <div class="mb-4">
                            <h4 class="font-weight-600"><span class="pr-1">•</span>Packaging audit</h4>
                            <p class="service-item-text text-gray-600">Identify and analyze your current packaging and spot areas of improvement for your packaging.</p>
                        </div>
                        <div class="mb-4">
                            <h4 class="font-weight-600"><span class="pr-1">•</span>Packaging strategy</h4>
                            <p class="service-item-text text-gray-600">Collaborate and develop a tailored packaging strategy with clear guidelines to meet your needs and goals.</p>
                        </div>
                        <div class="mb-4">
                            <h4 class="font-weight-600"><span class="pr-1">•</span>Cost optimization</h4>
                            <p class="service-item-text text-gray-600">Save more on your custom packaging with cost-optimized structures, production methods and smart supply chain optimization.</p>
                        </div>
                        <div>
                            <h4 class="font-weight-600"><span class="pr-1">•</span>Supply chain optimization</h4>
                            <p class="service-item-text text-gray-600">Analyze and improve your existing supply chain for the most efficient procurement network.</p>
                        </div>
                    </div>
                </div>

                <!-- 设计服务 -->
                <div class="flex flex-col item" data-aos="fade-up" data-aos-delay="300">
                    <div class="card-header bg-[rgb(35,186,152)] text-white flex items-center justify-center text-center h-32 rounded-t-md">
                        <h3 class="text-xl font-weight-600 mb-0 text-center">Design</h3>
                    </div>
                    <div class="bg-[rgb(223,223,223)] p-4  rounded-b-md flex-grow">
                        <div class="mb-4">
                            <h4 class="font-weight-600"><span class="pr-1">•</span>Packaging audit Packaging artwork design</h4>
                            <p class="service-item-text text-gray-600">Identify and analyze your current packaging and spot areas of improvement for your packaging.</p>
                        </div>
                        <div>
                            <h4 class="font-weight-600"><span class="pr-1">•</span>Packaging engineering & design</h4>
                            <p class="service-item-text text-gray-600">Turn complex challenges and ideas into design solutions tailored to your product requirements along with the right materials for goals.</p>
                        </div>
                    </div>
                </div>

                <!-- 原型服务 -->
                <div class="flex flex-col item" data-aos="fade-up" data-aos-delay="500">
                    <div class="card-header bg-[rgb(35,186,152)] text-white flex items-center justify-center text-center h-32 rounded-t-md">
                        <h3 class="text-xl font-weight-600 mb-0 text-center">Prototype</h3>
                    </div>
                    <div class="bg-[rgb(223,223,223)] p-4  rounded-b-md flex-grow">
                        <div class="mb-4">
                            <h4 class="font-weight-600"><span class="pr-1">•</span>Sampling & prototyping</h4>
                            <p class="service-item-text text-gray-600">Test and tweak your packaging and artwork with accurate samples prior to bringing your vision to the mass production.</p>
                        </div>
                        <div class="mb-4">
                            <h4 class="font-weight-600"><span class="pr-1">•</span>Conduct critical tests</h4>
                            <p class="service-item-text text-gray-600">Conduct critical tests like drop and crush tests on your custom packaging mocks on to be certain on metrics.</p>
                        </div>
                        <div>
                            <h4 class="font-weight-600"><span class="pr-1">•</span>Material optimization</h4>
                            <p class="service-item-text text-gray-600">Minimize material usage to reduce unnecessary packaging waste and environmental impact with smart design strategies.</p>
                        </div>
                    </div>
                </div>

                <!-- 生产服务 -->
                <div class="flex flex-col item" data-aos="fade-up" data-aos-delay="700">
                    <div class="card-header bg-[rgb(35,186,152)] text-white flex items-center justify-center text-center h-32 rounded-t-md">
                        <h3 class="text-xl font-weight-600 mb-0 text-center">Production</h3>
                    </div>
                    <div class="bg-[rgb(223,223,223)] p-4  rounded-b-md flex-grow">
                        <div class="mb-4">
                            <h4 class="font-weight-600"><span class="pr-1">•</span>Strategic sourcing</h4>
                            <p class="service-item-text text-gray-600">Get your packaging strategically produced with smart materials shipping costs and lower your carbon footprint.</p>
                        </div>
                        <div class="mb-4">
                            <h4 class="font-weight-600"><span class="pr-1">•</span>Managed production</h4>
                            <p class="service-item-text text-gray-600">Manufacture your packaging at managed facilities for top quality standards — reliable results no matter what you need.</p>
                        </div>
                        <div class="mb-4">
                            <h4 class="font-weight-600"><span class="pr-1">•</span>Multi-plant production</h4>
                            <p class="service-item-text text-gray-600">Build at entire product line in one place using a range of certified facilities experienced in packaging.</p>
                        </div>
                        <div>
                            <h4 class="font-weight-600"><span class="pr-1">•</span>Quality control management</h4>
                            <p class="service-item-text text-gray-600">Have confidence in your packaging materials through meticulous stringent quality control and monitoring.</p>
                        </div>
                    </div>
                </div>

                <!-- 物流服务 -->
                <div class="flex flex-col item" data-aos="fade-up" data-aos-delay="900">
                    <div class="card-header bg-[rgb(35,186,152)] text-white flex items-center justify-center text-center h-32 rounded-t-md">
                        <h3 class="text-xl font-weight-600 mb-0 text-center">Logistic</h3>
                    </div>
                    <div class="bg-[rgb(223,223,223)] p-4  rounded-b-md flex-grow">
                        <div class="mb-4">
                            <h4 class="font-weight-600"><span class="pr-1">•</span>Route optimization</h4>
                            <p class="service-item-text text-gray-600">Ensure on-time delivery with reduced costs by tracking your inventory with our dedicated logistics team.</p>
                        </div>
                        <div class="mb-4">
                            <h4 class="font-weight-600"><span class="pr-1">•</span>Cargo optimization</h4>
                            <p class="service-item-text text-gray-600">Keep costs low with optimized solutions designed to save pallet space and be efficient in the delivery.</p>
                        </div>
                        <div class="mb-4">
                            <h4 class="font-weight-600"><span class="pr-1">•</span>Just in-time delivery</h4>
                            <p class="service-item-text text-gray-600">Work with a dedicated product specialist to ensure all components of your packaging arrive when needed.</p>
                        </div>
                        <div>
                            <h4 class="font-weight-600"><span class="pr-1">•</span>End-to-end delivery</h4>
                            <p class="service-item-text text-gray-600">Let us handle every step of your packaging production cycle to ensure safety and efficiency.</p>
                        </div>
                    </div>
                </div>

                <!-- 优化服务 -->
                <div class="flex flex-col item" data-aos="fade-up" data-aos-delay="1100">
                    <div class="card-header bg-[rgb(35,186,152)] text-white flex items-center justify-center text-center h-32 rounded-t-md">
                        <h3 class="text-xl font-weight-600 mb-0 text-center">Optimize</h3>
                    </div>
                    <div class="bg-[rgb(223,223,223)] p-4  rounded-b-md flex-grow">
                        <div class="mb-4">
                            <h4 class="font-weight-600"><span class="pr-1">•</span>Customer satisfaction</h4>
                            <p class="service-item-text text-gray-600">Build a loyal customer base and make a great first impression with solutions optimized to your target market.</p>
                        </div>
                        <div class="mb-4">
                            <h4 class="font-weight-600"><span class="pr-1">•</span>Business optimization</h4>
                            <p class="service-item-text text-gray-600">Evaluate your packaging process line & workflow, budget to develop strategies for smooth & operations.</p>
                        </div>
                        <div>
                            <h4 class="font-weight-600"><span class="pr-1">•</span>Project optimization</h4>
                            <p class="service-item-text text-gray-600">Optimize your packaging for smoother factory operations & enhanced sustainability.</p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>
</template>
<style scoped lang="scss">
    .service-item-text {
        font-size: 15px;
        line-height: 1.2;
    }
    h4{
        line-height: 1;
        margin-bottom: 6px;
    }

    .item {
        &:hover {
            box-shadow: 0 20px 45px rgba(15, 118, 110, 0.28);
        }
    }

    .card-header {
        position: relative;
        overflow: hidden;

        &::before {
            content: "";
            position: absolute;
            top: -20%;
            left: -50%;
            width: 100%;
            height: 160%;
            /* 只保留一条细亮线，去掉大面积光晕 */
            background: linear-gradient(
                120deg,
                rgba(255, 255, 255, 0) 0%,
                rgba(255, 255, 255, 0) 42%,
                rgba(255, 255, 255, 0.95) 50%,
                rgba(255, 255, 255, 0) 58%,
                rgba(255, 255, 255, 0) 100%
            );
            opacity: 0;
            transform: translate3d(150%, 0, 0) rotate(18deg);
            pointer-events: none;
        }
    }

    .item:hover .card-header::before {
        animation: card-light-move 1.2s ease-out forwards;
    }

    @keyframes card-light-move {
        0% {
            opacity: 0;
            transform: translate3d(150%, 0, 0) rotate(18deg);
        }
        10% {
            opacity: 1;
        }
        90% {
            opacity: 1;
        }
        100% {
            opacity: 0;
            transform: translate3d(-130%, 0, 0) rotate(18deg);
        }
    }
</style>
